"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMapButton = function SvgMapButton(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46 46"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "map-button_svg__a",
    width: 46,
    height: 46,
    rx: 23
  }), /*#__PURE__*/React.createElement("path", {
    id: "map-button_svg__c",
    d: "M-.169 24.91c2.652-.778 4.38-1.536 5.185-2.276.806-.74 5.513-4.763 14.123-12.069 2.117-1.877 4.041-3.001 5.773-3.371 2.599-.555 7.955-1.969 11.17-4.384"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "map-button_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#map-button_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#75CFF0",
    xlinkHref: "#map-button_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4E0",
    stroke: "#73BAD4",
    d: "M44.963 15.903 27.937 34.594c-3.243-3.079-5.4-4.893-6.47-5.443-1.604-.825-2.337-.825-3.856 0-.835-.326-1.48-.72-1.937-1.184-1.17.153-1.755 1.054-1.755 2.703 0 1.65-.508 2.526-1.524 2.632-1.378.71-2.596.71-3.653 0s-1.869-.455-2.435.77c1.624 2.46 2.435 5.29 2.435 8.486S3.246 40.05-7.747 25.448L-3.412 5.18 20.745-8.353l15.945.884 10.092 14.13-1.818 9.242z",
    mask: "url(#map-button_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#map-button_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#D6D9E5",
    strokeWidth: 6,
    xlinkHref: "#map-button_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFF",
    strokeWidth: 4,
    xlinkHref: "#map-button_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m10.058 42.297 2.913-2.657-3.65-5.586m9.665-6.557-6.969-9.628m-8.799.976L1.768 17.3l-1.32-.86m2.227-3.968c1.895 1.042 3.054 2.365 3.476 3.969m29.346-8.2-7.396 5.4 7.396 8.65",
    mask: "url(#map-button_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 30,
    r: 4,
    fill: "#007AFF",
    stroke: "#fff",
    mask: "url(#map-button_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 10,
    r: 4,
    fill: "#007AFF",
    stroke: "#fff",
    mask: "url(#map-button_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 15,
    r: 4,
    fill: "#007AFF",
    stroke: "#fff",
    mask: "url(#map-button_svg__b)"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMapButton);
var _default = exports["default"] = Memo;